import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import EpButton from '../EpButton';
import EpLocalLoading from '../EpLocalLoading';

const EpEmpty = ({
  title, description, noButton, buttonText, loading, linkFunc,
}) => (
  !loading
    ? (
      <div className="empty">
        <h4 className="empty__title">{title}</h4>
        <h6 className="empty__description">{description}</h6>

        {!noButton && (
          (
            <EpButton
              linkFunc={linkFunc}
              labelText={buttonText}
              buttonType="primary-outline"
              customClass="empty__btn-apply-filters"
              buttonIcon={<FaCheck className="btn__icon" />}
              size="lg"
            />
          )

        )}
      </div>
    ) : (
      <div className="empty__loading">
        <EpLocalLoading />
      </div>
    )
);
export default EpEmpty;

EpEmpty.defaultProps = {
  description: '',
  noButton: false,
  buttonText: '',
  loading: false,
  linkFunc: null,
};

EpEmpty.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  noButton: PropTypes.bool,
  buttonText: PropTypes.string,
  loading: PropTypes.bool,
  linkFunc: PropTypes.func,
};
